import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchChargeTypesQuery } from '@/features/charge-types'
import { fetchChargeTypesList } from '@/features/charge-types/api'

import { ChargeTypesSearchSchema } from './-models/charge-types-search'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/charge-types/'
)({
  validateSearch: (search) => parse(ChargeTypesSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          enable: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchChargeTypesQuery(tenantKey, deps)
    return {
      authUser: auth.user,
      chargeTypes: await fetchChargeTypesList(query, abortController.signal)
    }
  }
})
